import Alpine from 'alpinejs';

import 'iconify-icon';

window.Alpine = Alpine;

window.addEventListener('DOMContentLoaded', () => {
    Alpine.start();
});
document.addEventListener("DOMContentLoaded", () => {
	const accordionParent = document.querySelector(".accordeon-atuacao");

	if (!accordionParent) return;

	let counter = 1;

	// Função para numerar os itens
	const addCountersToAccordion = () => {
	  const items = accordionParent.querySelectorAll(".wp-block-coblocks-accordion-item");

	  items.forEach((item) => {
		const summary = item.querySelector("summary");
		if (summary && !summary.dataset.numbered) {
		  summary.dataset.numbered = true; // Evita duplicar numeração

		  // Cria o contêiner do número
		  const numberSpan = document.createElement("span");
		  numberSpan.className = "accordion-number";
		  numberSpan.textContent = counter++;

		  // Adiciona o número ao início do summary
		  summary.insertAdjacentElement("afterbegin", numberSpan);
		}
	  });
	};

	// Inicialmente, numera os itens
	addCountersToAccordion();

	// Observa mudanças no DOM para atualizar a numeração
	const observer = new MutationObserver(() => {
	  addCountersToAccordion();
	});

	observer.observe(accordionParent, { childList: true, subtree: true });
});

//  ajuste de hover ao passar o mouse nas redes sociais
document.addEventListener("DOMContentLoaded", function () {
    const shareLinks = document.querySelector(".share-links--floating");
    shareLinks.addEventListener("mouseover", () => {
        shareLinks.classList.add("open");
    });
    shareLinks.addEventListener("mouseout", () => {
        shareLinks.classList.remove("open");
    });
});


jQuery(document).ready(function ($) {
	// Seleciona o slider dentro da classe .block-galery-1
	$('.block-galery-1 .wp-block-cb-carousel.slick-initialized.slick-slider').on('mouseenter', '.slick-slide', function () {
	  // Aplica zoom no slide
	  $(this).css({
		'transform': 'scale(1.1)',
		'z-index': '10'
	  });

	  // Exibe a legenda abaixo da imagem
	  $(this).find('.wp-element-caption').css({
		'opacity': '1',
		'visibility': 'visible'
	  });
	});

	$('.block-galery-1 .wp-block-cb-carousel.slick-initialized.slick-slider').on('mouseleave', '.slick-slide', function () {
	  // Remove o zoom do slide
	  $(this).css({
		'transform': 'scale(1)',
		'z-index': '1'
	  });

	  // Esconde a legenda
	  $(this).find('.wp-element-caption').css({
		'opacity': '0',
		'visibility': 'hidden'
	  });
	});
  });


jQuery(document).ready(function ($) {
    function initSlider() {
        if (!$('.related-posts__content').hasClass('slick-initialized')) {
            $('.related-posts__content').slick({
                slidesToShow: $(window).width() > 768 ? 3 : 1, // 3 no desktop, 1 no mobile
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                infinite: true,
                centerMode: true,
                centerPadding: $(window).width() > 768 ? '60px' : '20px', // Ajuste para efeito peek
            });
        }
    }

    initSlider();

    $(window).on('resize', function () {
        if ($('.related-posts__content').hasClass('slick-initialized')) {
            $('.related-posts__content').slick('unslick');
        }
        initSlider();
    });
});

